import React, {Component} from "react";
import MoneyInput from "./MoneyInput";
import MaskedInput from "react-maskedinput";
import {LOCAL} from "../../../../constants/local";

class OrderForm extends Component {
	hasErrors = true;
	requiredText = 'Поле обязательно для заполнения!';

	constructor(props) {
		super(props);
	}

	isEmpty(data) {
		if ( data === '' || data === null || data === 0 ) {
			return this.hasErrors = true;
		}

		return this.hasErrors = false;
	}

	isAmountValid() {
		if ( this.state.amount < this.props.minAmount ) {
			this.hasErrors = true;
			return false;
		}

		if ( this.props.maxAmount !== undefined && this.state.amount > this.props.maxAmount ) {
			this.hasErrors = true;
			return false;
		}

		this.hasErrors = false;
		return true;
	}

	amountChange(values) {
		this.setState({
			amount : values.value,
			toPay  : values.value,
			nalog  : values.value * 0.04
		});
	}

	amountBlur() {
		if ( this.state.amount < this.props.minAmount ) {
			this.setState({
				amount : this.props.minAmount
			});
		}
	}

	inputChange(e) {
		const stateChange = {
			[e.target.name] : e.target.value
		};

		this.setState({...this.state, ...stateChange})
	}

	// ПОЛЯ
	getAmountRow() {
		return (
			<div className="description__order-item">
				<div>
					<label htmlFor="amount">Сумма заказа:</label>
				</div>
				<div>
					<MoneyInput name="amount"
					            onBlur={this.amountBlur.bind(this)}
					            onValueChange={this.amountChange.bind(this)}
					            value={this.state.amount}/>
				</div>
				<div className="errors">
					{this.isEmpty(this.state.amount) && this.requiredText}
					{!this.isAmountValid() && `Минимальная сумма заказа ${this.props.minAmount} ${LOCAL.currency}!`}
					{!this.isAmountValid() && this.props.maxAmount !== undefined && this.state.amount > this.props.maxAmount && `Максимальная сумма заказа ${this.props.maxAmount} ${LOCAL.currency}!`}
				</div>
			</div>
		);
	}

	getToPayRow() {
		return (
			<div className="description__order-item">
				<div><label>Сумма к выплате: </label></div>
				<div><MoneyInput name="toPay" value={this.state.toPay} disabled={true}/></div>
			</div>
		);
	}

	getNalogRow() {
		return (
			<div className="description__order-item">
				<div><label>Налог: </label></div>
				<div><MoneyInput name="nalog" value={this.state.nalog} disabled={true}/></div>
			</div>
		);
	}

	getPhoneRow() {
		return (
			<div className="description__order-item">
				<div><label htmlFor="phone">Номер телефона: </label></div>
				<div>
					<MaskedInput id="phone"
					             name="phone"
					             mask="(11) 111-11-11"
					             onChange={this.inputChange.bind(this)}/>
				</div>
				<div className="errors">
					{this.isEmpty(this.state.phone) && this.requiredText}
				</div>
			</div>
		);
	}

	getPpsRow() {
		return (
			<div className="description__order-item">
				<div><label>ППС: </label></div>
				<div>
					<select value={this.state.selectedCash || 0} onChange={this.changeCash.bind(this)}>
						{this.cashes.map((cash) =>
							<option key={`cash_${cash.id}`} value={cash.id}>{cash.id !== null && `${cash.city}, ${cash.address}`}</option>)}
					</select>
				</div>
				<div className="errors">
					{this.isEmpty(this.state.selectedCash) && this.requiredText}
				</div>
			</div>
		);
	}

	getProviderRow() {
		return (
			<div className="description__order-item">
				<div><label>Провайдер: </label></div>
				<div>
					<select value={this.state.provider || 100} onChange={this.changeProvider.bind(this)}>
						<option key={`mts`} value={100}>MTS</option>
						<option key={`velcom`} value={101}>Velcom</option>
						<option key={`life`} value={102}>Life</option>
					</select>
				</div>
				<div className="errors">
					{this.isEmpty(this.state.provider) && this.requiredText}
				</div>
			</div>
		);
	}

	getOrderButton() {
		return (
			<div className="description__order-item">
				<div></div>
				<div className="buttons">
					<button className='buttons__show' onClick={this.onSubmit.bind(this)}>
						Заказать на выплату
					</button>
				</div>
			</div>
		);
	}

	onSubmit() {

	}
}

export default OrderForm;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/OrderForm.js